module.exports = __webpack_public_path__ + "media/images/views/home/home-features-photo-1-010446aaafd964ac92dbd5a9d79fcc76.png";